var map = {
	"./1.jpg": "Boly",
	"./10.jpg": "90O4",
	"./11.png": "VGBo",
	"./12.jpg": "koug",
	"./13.jpg": "tssL",
	"./14.jpg": "2Prp",
	"./15.jpg": "Kemg",
	"./16.jpeg": "j8j5",
	"./17.jpeg": "Fsji",
	"./18.jpg": "x6r1",
	"./19.jpg": "YZZL",
	"./2.jpg": "Vu2s",
	"./20.jpg": "BTX9",
	"./21.jpg": "U6F8",
	"./22.jpg": "YUsF",
	"./23.jpg": "IU23",
	"./24.jpg": "Fe/S",
	"./3.jpg": "igK1",
	"./4.jpg": "a4wH",
	"./5.jpeg": "t5Rn",
	"./6.jpeg": "Nz42",
	"./7.jpg": "66UQ",
	"./8.jpg": "eeiI",
	"./9.jpg": "GCoy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zD2M";